import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { IPpdPricesDto } from '@r1-frontend/api-domru/ppd-service/dto/IPpdPricesDto';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { DATA_IMAGES_TAB, TEXT_BANNER, TEXT_STEPS } from '~/src/features/center/constants/data';
import { COUNT_SLOTS } from '~/src/features/center/constants/ordinary';
import FormCallback from '~/src/features/center/FormCallback';
import Header from '~/src/features/center/Header';
import type { TRef } from '~/src/features/center/InfoBlocks';
import InfoBlocks from '~/src/features/center/InfoBlocks';
import PanelTab from '~/src/features/center/PanelTab';
import StepsBanner from '~/src/features/center/StepsBanner';
import { getDataForSlots, getUrlsForBannerImages } from '~/src/features/center/utils';
import { selectCompanyName } from '~/src/store/selectors/city';

interface IProps {
    city: ICurrentCity,
    dataPrices: IPpdPricesDto[],
}

const Center: React.FC<IProps> = ({ city, dataPrices }) => {
    const footerRef = useRef<HTMLDivElement | null>(null);
    const slotsArray: TRef = [...Array(COUNT_SLOTS)].map(() => React.createRef());
    const slotRefs = useRef<TRef>(slotsArray);
    const companyName = useSelector(selectCompanyName);

    return (
        <>
            <Header
                withForm={true}
                footerRef={footerRef}
                companyName={companyName}
            />
            <PanelTab
                icons={DATA_IMAGES_TAB}
                slotRefs={slotRefs}
            />
            <StepsBanner
                title={TEXT_BANNER}
                textSteps={TEXT_STEPS}
                urls={getUrlsForBannerImages()}
            />
            <InfoBlocks
                data={getDataForSlots()}
                city={city}
                slotRefs={slotRefs}
                dataPrices={dataPrices}
            />
            <FormCallback
                footerRef={footerRef}
                city={city}
            />
        </>
    );
};

export default Center;
